import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FaInstagram,
  FaLinkedinIn,
  FaWhatsapp,
  FaEnvelope,
  FaBehance,
} from "react-icons/fa";

const headerData = {
  name: "Lutfi Riani",
  designation: "Software Engineering",
  imageThumb: "/images/logo1.png",
  social: {
    instagram: "https://www.instagram.com/lutfi_riani/",
    linkedin: "https://www.linkedin.com/in/lutfi-riani",
    whatsapp: "https://wa.me/6281227173265",
    gmail: "mailto:lutfiriani1510@gmail.com",
    behance: "https://www.behance.net/lutfirianiproject",
  },
};

function Header({ toggleHeader, toggleHandler }) {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <>
      <div
        className={
          toggleHeader
            ? "mobile-header py-2 px-3 mt-4 push"
            : "mobile-header py-2 px-3 mt-4"
        }
      >
        <button className="menu-icon mr-2" onClick={toggleHandler}>
          <span></span>
          <span></span>
          <span></span>
        </button>
        <Link to="/" className="logo">
          <img src={headerData.imageThumb} alt={headerData.name} />
        </Link>
        <Link to="/" className="site-title dot ml-2">
          {headerData.name}
        </Link>
      </div>

      <header
        className={
          toggleHeader
            ? "left float-left shadow-dark open"
            : "left float-left shadow-dark"
        }
      >
        <button
          type="button"
          className="close"
          aria-label="Close"
          onClick={toggleHandler}
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div className="header-inner d-flex align-items-start flex-column">
          <Link to="/">
            <img src={headerData.imageThumb} alt={headerData.name} />
          </Link>
          <Link to="/" className="site-title dot mt-3">
            {headerData.name}
          </Link>

          <span className="site-slogan">{headerData.designation}</span>

          <nav>
            <ul className="vertical-menu scrollspy">
              <li>
                <Link to="/" className={currentPath === "/" ? "active" : ""}>
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className={currentPath === "/about" ? "active" : ""}
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className={currentPath === "/services" ? "active" : ""}
                >
                  Skills
                </Link>
              </li>
              <li>
                <Link
                  to="/resume"
                  className={currentPath === "/resume" ? "active" : ""}
                >
                  Experiences
                </Link>
              </li>
              <li>
                <Link
                  to="/works"
                  className={currentPath === "/works" ? "active" : ""}
                >
                  Portofolio
                </Link>
              </li>
              <li>
                <Link
                  to="/certificates"
                  className={currentPath === "/certificates" ? "active" : ""}
                >
                  Certificates
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className={currentPath === "/contact" ? "active" : ""}
                >
                  Contact
                </Link>
              </li>
            </ul>
          </nav>

          <div className="footer mt-auto">
            <ul className="social-icons list-inline">
              {headerData.social.instagram && (
                <li className="list-inline-item">
                  <a
                    href={headerData.social.instagram}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaInstagram />
                  </a>
                </li>
              )}
              {headerData.social.linkedin && (
                <li className="list-inline-item">
                  <a
                    href={headerData.social.linkedin}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaLinkedinIn />
                  </a>
                </li>
              )}
              {headerData.social.whatsapp && (
                <li className="list-inline-item">
                  <a
                    href={headerData.social.whatsapp}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaWhatsapp />
                  </a>
                </li>
              )}
              {headerData.social.gmail && (
                <li className="list-inline-item">
                  <a href={headerData.social.gmail}>
                    <FaEnvelope />
                  </a>
                </li>
              )}
              {headerData.social.behance && (
                <li className="list-inline-item">
                  <a
                    href={headerData.social.behance}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FaBehance />
                  </a>
                </li>
              )}
            </ul>

            <span className="copyright">
              &copy; {new Date().getFullYear()}
            </span>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
